import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
import CabinetCsvExportColumnModal from './cabinetCsvExportColumnModal';
const ModalNotification = _ref => {
  var _content$selectionRef, _content$selectionRef2, _content$selectionRef3, _content$selectionRef4;
  let list = _ref.list;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    setExportButtonVersion = _useState2[1];
  const onExportReadyChange = useCallback(() => setExportButtonVersion(version => version + 1), []);
  if (list.length === 0) {
    return null;
  }
  const _list = _slicedToArray(list, 1),
    content = _list[0].content;
  const isCabinetCsvExport = content.modalKind === 'cabinetCsvExportColumns';
  const isExportReady = (_content$selectionRef = (_content$selectionRef2 = content.selectionRef) === null || _content$selectionRef2 === void 0 ? void 0 : _content$selectionRef2.isExportReady) !== null && _content$selectionRef !== void 0 ? _content$selectionRef : false;
  const isLoadingColumns = (_content$selectionRef3 = (_content$selectionRef4 = content.selectionRef) === null || _content$selectionRef4 === void 0 ? void 0 : _content$selectionRef4.isLoadingColumns) !== null && _content$selectionRef3 !== void 0 ? _content$selectionRef3 : false;
  const buttons = ['left', 'middle', 'right'].map(direction => {
    let label = content["".concat(direction, "ButtonLabel")];
    let disabled = content["".concat(direction, "ButtonDisabled")];
    if (direction === 'right' && isCabinetCsvExport) {
      if (isExportReady) {
        label = 'Export';
        disabled = false;
      } else if (isLoadingColumns) {
        label = 'Loading columns...';
        disabled = true;
      } else {
        label = 'Export';
        disabled = true;
      }
    }
    const action = content["".concat(direction, "ButtonAction")];
    const color = content["".concat(direction, "ButtonColor")];
    if (!label) return undefined;
    return /*#__PURE__*/React.createElement(Button, {
      key: "btn-".concat(label),
      color: color,
      disabled: disabled,
      onClick: () => action()
    }, label);
  });
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    style: {
      maxWidth: '800px'
    }
  }, /*#__PURE__*/React.createElement(ModalHeader, null, content.headerMessage), /*#__PURE__*/React.createElement(ModalBody, {
    style: {
      whiteSpace: 'pre-line',
      wordBreak: 'break-word'
    }
  }, content.modalKind === 'cabinetCsvExportColumns' ? /*#__PURE__*/React.createElement(CabinetCsvExportColumnModal, {
    formTypes: content.formTypes,
    totalCount: content.totalCount,
    selectionRef: content.selectionRef,
    loadColumnOptions: content.loadColumnOptions,
    onExportReadyChange: onExportReadyChange
  }) : content.message), /*#__PURE__*/React.createElement(ModalFooter, null, buttons));
};
ModalNotification.propTypes = {
  notificationActions: PropTypes.shape({
    dismiss: PropTypes.func
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export { ModalNotification as TestModalNotification };
export default entityComposition(ModalNotification, [], {}, ['notification']);